(function () {
  'use strict';
  var root, cfg, state = { tier: 0, picks: [], addons: {} };
  function money(c) { c = Math.round(c); return cfg.moneyFormat ? cfg.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)) : '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }
  function tier() { return cfg.tiers[state.tier]; }
  function opts() { return cfg.options || []; }
  function total() { var s = tier().price; (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) s += a.price; }); return s; }
  function findVariant(vals) {
    for (var i = 0; i < cfg.variants.length; i++) { var v = cfg.variants[i], ok = true;
      for (var j = 0; j < vals.length; j++) if ((v.options || [])[j] !== vals[j]) { ok = false; break; }
      if (ok) return v; }
    return null;
  }
  function isSize(o) { return /size|talla|taille|gr\u00f6\u00dfe/i.test(o.name); }
  function unitHtml(u, qty) {
    var h = '<div class="bbdl__pick" data-unit="' + u + '">';
    h += '<div class="bbdl__pickLabel">' + (qty > 1 ? (cfg.unitWord || 'Item') + ' ' + (u + 1) : (cfg.pickLabel || 'Choose')) + '</div>';
    opts().forEach(function (o, oi) {
      var cur = state.picks[u][oi];
      if (isSize(o)) {
        h += '<div class="bbdl__optName">' + esc(o.name) + ': <b>' + esc(cur) + '</b></div><div class="bbdl__pills">';
        o.values.forEach(function (val) { var tv = state.picks[u].slice(); tv[oi] = val; var vv = findVariant(tv), off = !vv || !vv.available; h += '<button type="button" class="bbdl__pill' + (val === cur ? ' is-on' : '') + (off ? ' is-off' : '') + '"' + (off ? ' disabled title="Sold out"' : '') + ' data-unit="' + u + '" data-opt="' + oi + '" data-val="' + esc(val) + '">' + esc(val) + '</button>'; });
        h += '</div>';
      } else {
        h += '<select class="bbdl__select" aria-label="' + esc(o.name) + '" data-unit="' + u + '" data-opt="' + oi + '">';
        o.values.forEach(function (val) { h += '<option value="' + esc(val) + '"' + (val === cur ? ' selected' : '') + '>' + esc(val) + '</option>'; });
        h += '</select>';
      }
    });
    return h + '</div>';
  }
  function render() {
    var h = '';
    if (cfg.sizeChart) h += '<div class="bbdl__scrow"><button type="button" class="bbdl__scbtn"><svg width="22" height="12" viewBox="0 0 22 12" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="1" y="1" width="20" height="10" rx="1.5"/><path d="M5 1v4M9 1v3M13 1v4M17 1v3"/></svg><span>Size Chart</span></button></div>';
    if (cfg.label) h += '<p class="bbdl__label">' + cfg.label + '</p>';
    cfg.tiers.forEach(function (tr, i) {
      var on = i === state.tier;
      h += '<div class="bbdl__tier' + (on ? ' is-on' : '') + (tr.badge ? ' has-badge' : '') + '" data-tier="' + i + '">' + (tr.badge ? '<div class="bbdl__badge">' + esc(tr.badge) + '</div>' : '') + '<label class="bbdl__head">';
      h += '<input type="radio" class="bbdl__radio" name="bbdl-tier" value="' + i + '"' + (on ? ' checked' : '') + '>';
      h += '<span class="bbdl__ht"><span class="bbdl__title">' + tr.title + '</span>' + (tr.subtitle ? '<span class="bbdl__sub">' + tr.subtitle + '</span>' : '') + '</span>';
      h += '<span class="bbdl__pr"><span class="bbdl__price">' + money(tr.price) + '</span>' + (tr.compareAt > tr.price ? '<span class="bbdl__was">' + money(tr.compareAt) + '</span>' : '') + '</span></label>';
      h += '<div class="bbdl__body">';
      if (on && opts().length) for (var u = 0; u < tr.qty; u++) h += unitHtml(u, tr.qty);
      if (cfg.addons && cfg.addons.length) {
        h += '<div class="bbdl__addons">';
        cfg.addons.forEach(function (a) {
          h += '<label class="bbdl__addon"><input type="checkbox" class="bbdl__cb" data-addon="' + a.id + '"' + (state.addons[a.id] ? ' checked' : '') + '>';
          if (a.image) h += '<img class="bbdl__thumb" src="' + a.image + '" alt="" loading="lazy">';
          h += '<span class="bbdl__an">+ ' + esc(a.title) + '</span><span class="bbdl__ap">' + money(a.price) + (a.compareAt > a.price ? '<s>' + money(a.compareAt) + '</s>' : '') + '</span></label>';
        });
        h += '</div>';
      }
      h += '</div></div>';
    });
    h += '<div class="bbdl__total"><span>' + (cfg.totalLabel || 'Total') + '</span><b data-total></b></div>';
    h += '<button type="button" class="bbdl__cta">' + (cfg.ctaLabel || 'Add to cart') + '</button>';
    h += '<p class="bbdl__err">' + (cfg.errorText || 'Please choose an option for every item.') + '</p>';
    root.innerHTML = h;
    root.querySelector('[data-total]').textContent = money(total());
  }
  function unitVariant(u) { return opts().length ? findVariant(state.picks[u]) : cfg.variants[0]; }
  function ready() { for (var i = 0; i < tier().qty; i++) { var v = unitVariant(i); if (!v || !v.available) return false; } return true; }
  function onChange(e) {
    var el = e.target;
    if (el.name === 'bbdl-tier') { state.tier = parseInt(el.value, 10); render(); return; }
    if (el.hasAttribute('data-opt')) { state.picks[+el.getAttribute('data-unit')][+el.getAttribute('data-opt')] = el.value; root.classList.remove('has-error'); render(); return; }
    if (el.hasAttribute('data-addon')) { state.addons[el.getAttribute('data-addon')] = el.checked; root.querySelector('[data-total]').textContent = money(total()); }
  }
  function onClick(e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var pill = t.closest('.bbdl__pill');
    if (pill) { var u = +pill.getAttribute('data-unit'), oi = +pill.getAttribute('data-opt'), val = pill.getAttribute('data-val');
      state.picks[u][oi] = val; var box = pill.parentNode;
      [].forEach.call(box.querySelectorAll('.bbdl__pill'), function (p) { p.classList.toggle('is-on', p === pill); });
      var nm = box.previousElementSibling && box.previousElementSibling.querySelector('b'); if (nm) nm.textContent = val;
      root.classList.remove('has-error'); return; }
    if (t.closest('.bbdl__scbtn')) { var d = document.getElementById(cfg.sizeChart); if (d) { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); } return; }
    if (t.closest('.bbdl__cta')) addToCart();
  }
  function addToCart() {
    var btn = root.querySelector('.bbdl__cta');
    if (!ready()) { var er = root.querySelector('.bbdl__err'); if (er) er.textContent = 'That design and size combination is sold out \u2013 please pick another size.'; root.classList.add('has-error'); return; }
    root.classList.remove('has-error'); btn.disabled = true;
    var items = [], counts = {}, order = [];
    for (var i = 0; i < tier().qty; i++) { var id = unitVariant(i).id; if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; }
    order.forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
    (cfg.addons || []).forEach(function (a) { if (state.addons[a.id]) items.push({ id: Number(a.id), quantity: 1 }); });
    fetch(cfg.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (cfg.afterAdd === 'drawer' && document.querySelector('#cart-icon-bubble')) { try { sessionStorage.setItem('bbdl_open', '1'); } catch (e) {} window.location.reload(); return; }
        window.location.href = cfg.afterAdd === 'checkout' ? cfg.routes.checkout : cfg.routes.cart;
      })
      .catch(function () { btn.disabled = false; var er = root.querySelector('.bbdl__err'); if (er) er.textContent = 'Something went wrong adding to cart \u2013 please try again.'; root.classList.add('has-error'); });
  }
  function boot() {
    root = document.getElementById('bundle-builder');
    var node = document.getElementById('bundle-builder-config');
    if (!root || !node) return;
    try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
    if (!cfg.tiers || !cfg.tiers.length || !cfg.variants || !cfg.variants.length) return;
    var first = cfg.variants.filter(function (v) { return v.available; })[0] || cfg.variants[0];
    var maxQty = cfg.tiers.reduce(function (m, t) { return Math.max(m, t.qty); }, 1);
    for (var i = 0; i < maxQty; i++) state.picks.push((first.options || []).slice());
    (cfg.addons || []).forEach(function (a) { state.addons[a.id] = !!a.checked; });
    root.classList.add('bbdl'); render();
    root.addEventListener('change', onChange); root.addEventListener('click', onClick);
    var reopen = false; try { reopen = sessionStorage.getItem('bbdl_open') === '1'; sessionStorage.removeItem('bbdl_open'); } catch (e) {}
    if (reopen) setTimeout(function () { var ic = document.querySelector('#cart-icon-bubble'); if (ic) ic.click(); }, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
